<script lang="ts" setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import MenuItem from '@/components/menu/common/item.vue';
import SectionWrapper from '@/components/menu/sections/section-wrapper.vue';
import { useTeamInfo } from '@/utils/swr';
import { useIsAdmin } from '@/utils/user';

/**
 * 移行期間中は既存のメニューと項目が重複する。
 * ANDEV_10131_CAPABILITY の削除時は、置き換え元の
 * menu/sections/admin-menu.vue と menu/sections/settings-menu.vue を削除する。
 */

const route = useRoute();
const { isAdmin } = useIsAdmin();
const { data: teamInfo } = useTeamInfo();

// 海外メディアを使う契約のときだけ出す（settings-menu.vue の条件を引き継ぐ）
const showMediaDisplaySetting = computed(
  () => !!teamInfo.value?.enable_foreign_lang_media,
);

// テーマのメンバー一覧でもテーマ管理を選択状態にする
const isThemeAdminSelected = computed(() =>
  route.path.startsWith('/admin/themes/'),
);
</script>
<template>
  <SectionWrapper>
    <div class="item-list">
      <div class="title-icon c-title-bold--s">
        <span class="title">個人の設定</span>
      </div>
      <div class="items">
        <ul class="list-style--none">
          <li>
            <MenuItem
              id="settings_email"
              name="メール配信"
              :route="{ name: 'userSettingsEmail' }"
            ></MenuItem>
          </li>
          <li>
            <MenuItem
              id="settings_news"
              name="ニュース配信"
              :route="{ name: 'userSettingsNews' }"
            ></MenuItem>
          </li>
          <li>
            <MenuItem
              id="settings_notification"
              name="通知"
              :route="{ name: 'userSettingsNotification' }"
            ></MenuItem>
          </li>
          <li>
            <MenuItem
              id="settings_mark"
              name="マーク"
              :route="{ name: 'userSettingsMark' }"
            ></MenuItem>
          </li>
          <li v-if="showMediaDisplaySetting">
            <MenuItem
              id="settings_media_display"
              name="メディアの表示"
              :route="{ name: 'settingsMediaDisplay' }"
            ></MenuItem>
          </li>
        </ul>
      </div>
    </div>

    <template v-if="isAdmin">
      <div class="section-divider"></div>
      <div class="item-list">
        <div class="title-icon c-title-bold--s">
          <span class="title">管理者の設定</span>
        </div>
        <div class="items">
          <ul class="list-style--none">
            <li>
              <MenuItem
                id="admin_theme"
                name="テーマ管理"
                :route="{ name: 'themeAdmin' }"
                :is-selected="isThemeAdminSelected"
              ></MenuItem>
            </li>
            <li>
              <MenuItem
                id="admin_group"
                name="グループ管理"
                :route="{ name: 'groupAdmin' }"
              ></MenuItem>
            </li>
            <li>
              <MenuItem
                id="environment"
                name="環境設定"
                :route="{ name: 'environmentSettings' }"
              ></MenuItem>
            </li>
          </ul>
        </div>
      </div>
    </template>
  </SectionWrapper>
</template>
<style lang="scss" scoped>
/** memo: 汎化可能  */
.list-style--none {
  list-style: none;
}
.c-title-bold--s {
  padding: 4px;
}

// SectionWrapperの左右paddingを打ち消して、パネルの端まで線を引く
.section-divider {
  flex-shrink: 0;
  margin: 0 -24px;
  border-top: 1px solid $color-gray400;
}
</style>
